import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SimpleModalService } from "ngx-simple-modal";
import { PlanService } from "src/app/services/actions/plan.service";
import { UserService } from "src/app/services/user.service";
import { LgpdComponent } from "../../lgpd/lgpd.component";
import _ from 'lodash'

@Component({
	selector: "app-inicio-logado",
	templateUrl: "./inicio-logado.component.html",
	styleUrls: ["./inicio-logado.component.scss"],
})

export class InicioLogadoComponent implements OnInit {
	user: any
	bancario: any
	newUser = false
	confirmAccept = null;
	planStatus = {
		ATIVO: 1,
		VENCIDO: 2,
		CANCELADO: 3,
		AGUARDANDO_PAGAMENTO: 4
	}
	hasActivePlan = true
	userPlans: any
	noImage: boolean = true;
	hasNoAgenda: boolean = false;
	hasNoAboutMe: boolean = false;

	constructor(
		private userService: UserService,
		private planService: PlanService,
		private LgpdModal: SimpleModalService,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit() {
		if (!localStorage.getItem("lgpd")) {
			this.userService.lgpd().subscribe(
				(res) => {
					if (!res) {
						this.openLgbtModal()
					}
				},
				(err) => {}
			)
			localStorage.setItem("lgpd", JSON.stringify(true))
		}
		this.getUserPlans(this.userService.getId())
		this.activatedRoute.queryParams.subscribe((params) => this.newUser = params['newUser'])
		this.userService.getPerfil().subscribe(
			(res) => {
				this.user = res['profissional']
				this.bancario = res['bancario']
				if (this.user.image) this.noImage = false
				if (_.isEmpty(this.user.apresentacao)) this.hasNoAboutMe = true
				this.verifyAgenda()
			},
			(err) => {}
		)
	}

	getUserPlans (userId) {
		this.planService
			.getUserPlans(userId)
			.subscribe(
				(res) => {
					if (res[0]) {
						this.userPlans = res
						const plansActives = this.userPlans.filter((item) => { return item.status === this.planStatus.ATIVO })
						this.hasActivePlan = _.size(plansActives) > 0 ? true : false
					} else {
						this.hasActivePlan = false
					}
				},
				(err) => {
					console.log(err)
				}
			)
  	}

	verifyAgenda() {
		this.userService.getPerfilHasAgenda().subscribe(
			(res) => {
				if (res === 0) {
					this.hasNoAgenda = true
				}
			},
			(err) => console.log(err)
		)
	}

	openLgbtModal () {
		this.LgpdModal.addModal(LgpdComponent, {
			title: 'Atualização da política de privacidade',
			message: ''
		})
		.subscribe((isConfirmed) => {
			this.confirmAccept = isConfirmed
		})
	}
}
